import { useEffect } from 'react';

const SUFFIX = 'CerebralMachines Denial Management';

/**
 * Set the browser tab title for a page. Restores the previous title on
 * unmount so transient screens do not leak their title to subsequent pages.
 */
export default function usePageTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} · ${SUFFIX}` : SUFFIX;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
